import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";
import { useEffect, useState } from "react";
import { getChartData, getDashboardReport } from "../../actions/charts/chart";
import { toast } from "react-toastify";
import ChartTwo from "../../components/Charts/ChartTwo";
import ChartLine from "../../components/Charts/ChartLine";
import Footer from "../authentication/components/Footer";
import { useLocation } from "react-router-dom";
import { ShimmerPostList } from "react-shimmer-effects";
import CustomLoader from "../../components/Loading/TopBarLoader";

function Dashboard() {
  const [pending, setLoading] = useState(true);
  const { sales, tasks } = reportsLineChartData;
  const [charts, setChartData] = useState([]);
  const [chartsRecargo, setChartRecargoData] = useState([]);
  const [chartWeight, setChartWeight] = useState([]);
  const [chartReWeight, setChartReWeight] = useState([]);
  const [chartEquipment, setChartEquipment] = useState([]);
  const [chartReEquipment, setChartReEquipment] = useState([]);
  const [chartWeightEquipment, setChartWeightEquipment] = useState([]);
  const [chartReWeightEquipment, setChartReWeightEquipment] = useState([]);
  const [chartAmount, setChartAmount] = useState([]);
  const [chartJens, setChartJens] = useState([]);
  const [chartReJens, setChartReJens] = useState([]);
  const [chartWeightUser, setChartWeightUser] = useState([]);
  const [chartREWeightUser, setChartReWeightUser] = useState([]);
  const [chartUserCargo, setChartUserCargo] = useState([]);
  const [chartUserReCargo, setChartUserReCargo] = useState([]);

  // تعداد گزارشات
  const [countAllReport , setCountAllReport] = useState({count_all:"--",count_charge:"--",
  count_recharge:"--",count_users:"--"});

  useEffect(() => {
    async function getChart() {
      try {
        setLoading(true);
        const data = await getChartData();
        setLoading(false);
        setChartData(data.message.Cargo);
        setChartRecargoData(data.message.ReCargo);
        setChartWeight(data.message.Weight);
        setChartReWeight(data.message.ReWeight);
        setChartEquipment(data.message.Equipment);
        setChartReEquipment(data.message.ReEquipment);
        setChartWeightEquipment(data.message.WeightEquipment);
        setChartReWeightEquipment(data.message.WeightReEquipment);
        setChartAmount(data.message.AmountMachine);
        setChartJens(data.message.Jens);
        setChartReJens(data.message.ReJens);
        setChartWeightUser(data.message.UserWeight);
        setChartReWeightUser(data.message.UserReWeight);
        setChartUserCargo(data.message.UserCountCargo);
        setChartUserReCargo(data.message.UserCountReCargo);
      } catch (e) {
        toast.error("خطا در اتصال به سرور!");
      }
    }

    async function fetchDashboardReport(){
      try{
        const data = await getDashboardReport();
        setCountAllReport({count_all:data.message.all_cargos,count_charge:data.message.charge,
          count_recharge:data.message.Recharge,count_users:data.message.userCount});
      }catch (error) {
        toast.error("خطا در دریافت گزارشات!");
      }
    }

    getChart();
    fetchDashboardReport();
  }, []);

  return (
    <>
      <CustomLoader isLoading={pending} />
      <DashboardLayout>
        {pending ? (
          <ShimmerPostList postStyle="STYLE_SIX" col={2} row={3} gap={30} />
        ) : (
          <MDBox py={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="dark"
                    icon="factory"
                    title="مجموع بارگیری و تخلیه بار"
                    count={countAllReport.count_all}
                    percentage={{
                      color: "success",
                      amount: "+55%",
                      label: "than lask week",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    icon="person_add"
                    title="تعداد کاربران"
                    count={countAllReport.count_users}
                    percentage={{
                      color: "success",
                      amount: "+3%",
                      label: "than last month",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="success"
                    icon="local_shipping"
                    title="تخلیه بار ها"
                    count={countAllReport.count_recharge}
                    percentage={{
                      color: "success",
                      amount: "+1%",
                      label: "than yesterday",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="primary"
                    icon="leaderboard"
                    title="بارگیری ها"
                    count={countAllReport.count_charge}
                    percentage={{
                      color: "success",
                      amount: "",
                      label: "Just updated",
                    }}
                  />
                </MDBox>
              </Grid>
            </Grid>
            <MDBox mt={4.5}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 دستگاه با بیشترین تعداد بارگیری"
                      chart={
                        <ChartTwo
                          data={charts}
                          sub_title={"تعداد"}
                          title={"20 دستگاه با بیشترین تعداد بارگیری"}
                        />
                      }
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 دستگاه با بیشترین تعداد تخلیه"
                      chart={<ChartTwo data={chartsRecargo} sub_title={"تعداد"} title={""} />}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 دستگاه با بيشترين وزن بارگيری"
                      chart={<ChartTwo data={chartWeight} sub_title={"وزن"} title={""} />}
                    />
                  </MDBox>
                </Grid>
              </Grid>
              <Grid container spacing={3} mt={2.5}>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 دستگاه با بيشترين وزن تخليه"
                      chart={<ChartLine data={chartReWeight} sub_title={"وزن"} title={""} />}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 تجهيز با بيشترين تعداد بارگيری"
                      chart={<ChartLine data={chartEquipment} sub_title={"تعداد"} title={""} />}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 تجهيز با بيشترين وزن تخلیه"
                      chart={
                        <ChartLine data={chartReWeightEquipment} sub_title={"وزن"} title={""} />
                      }
                    />
                  </MDBox>
                </Grid>
              </Grid>
              <Grid container spacing={3} mt={2.5}>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 کالا بار با بيشترين وزن بارگيری"
                      chart={<ChartLine data={chartJens} sub_title={"وزن"} title={""} />}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 دستگاه با بيشترين کرايه دريافتی"
                      chart={<ChartLine data={chartAmount} sub_title={"مبلغ"} title={""} />}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 تجهیز با بيشترين وزن بارگیری"
                      chart={<ChartLine data={chartWeightEquipment} sub_title={"وزن"} title={""} />}
                    />
                  </MDBox>
                </Grid>
              </Grid>
              <Grid container spacing={3} mt={2.5}>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 کالا بار با بيشترين وزن تخلیه"
                      chart={<ChartTwo data={chartReJens} sub_title={"وزن"} title={""} />}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 مسئول عمليات با بيشترين وزن بارگيری"
                      chart={<ChartTwo data={chartWeightUser} sub_title={"وزن"} title={""} />}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 مسئول عمليات با بيشترين تعداد بارگيری"
                      chart={<ChartTwo data={chartUserCargo} sub_title={"تعداد"} title={""} />}
                    />
                  </MDBox>
                </Grid>
              </Grid>
              <Grid container spacing={3} mt={2.5}>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 مسئول عمليات با بيشترين تعداد تخليه"
                      chart={<ChartTwo data={chartUserReCargo} sub_title={"تعداد"} title={""} />}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <MDBox mb={3}>
                    <ReportsBarChart
                      color="light"
                      title=""
                      description=""
                      date="20 مسئول عمليات با بيشترين وزن تخلیه"
                      chart={<ChartTwo data={chartREWeightUser} sub_title={"وزن"} title={""} />}
                    />
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
        )}
        <br />
        <Footer dark />
      </DashboardLayout>
    </>
  );
}

export default Dashboard;
